// extracted by mini-css-extract-plugin
module.exports = {"edit-warning":"ConnectionSubscriptionsWarning_edit-warning__1MJDj","error-msg":"ConnectionSubscriptionsWarning_error-msg__wWoXT"};